import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit {
  paginatorConfig: MatPaginator = {} as any;
  @ViewChild('paginator') paginator: MatPaginator = {} as any;
  @Input('paginatorLength') set paginatorLength(length: number) {
    this.paginatorConfig.length = length;
  }
  @Input() pageSize: number = 25;
  constructor() { }

  ngOnInit() {
    this.paginatorConfig.pageSize = this.pageSize;
    this.paginatorConfig.pageSizeOptions = [10, 25, 50];
  }
}
